import { UserInvitationStatus } from 'generated/graphql';

export const USER_INVITATION_STATUSES: Record<UserInvitationStatus, string> = {
  [UserInvitationStatus.Pending]: 'čaká na prijatie',
  [UserInvitationStatus.Accepted]: 'prijatá',
  [UserInvitationStatus.Cancelled]: 'zrušená',
};

export const USER_INVITATION_STATUS_CHOICES = Object.entries(USER_INVITATION_STATUSES)
  .map(([id, name]) => ({ id, name }))
  .sort((a, b) => a.name.localeCompare(b.name));
